module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "content-icons-ui": "static-1.2309"
    },
    "depPathPrefixes": {
      "content-icons-ui": "/content-icons-ui/static-1.2309"
    },
    "bundlingPackage": "universal-recording-review-public-ui",
    "bundlingPackageVersion": "static-1.912",
    "project": "content-icons-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};